import { AppsLink } from '@wellesley/router'
import { cn } from '@wellesley/ui'
import { FC } from 'react'
import { Application, EntryPoint } from '@wellesley/openapi'
import { AppAvatar } from '../AppAvatar'
import { useLocation } from 'react-router-dom'
import { useSetLastApp } from './hooks/last-app'
import { useGetAppLink } from './hooks/useGetAppLink'

export type AppListSize = 'sm' | 'lg'

type ItemProps = {
  app: Application
  size: AppListSize
  isActive?: boolean
  username?: string
  groupname?: string
  entryPoint: EntryPoint
}

export const Item: FC<ItemProps> = ({ app, size, username, groupname }) => {
  const link = useGetAppLink()(app)
  const location = useLocation()
  const isActive = location.pathname === link

  useSetLastApp({ link, username, groupname, isActive })

  return (
    <div className="group flex flex-row items-center justify-between rounded hover:bg-slate-200">
      <AppsLink to={link} className="w-full">
        <div
          className={cn('flex flex-row items-center  rounded-sm  p-1', {
            'bg-white text-blue_100': isActive,
          })}
        >
          <AppAvatar name={app.name} icons={app.manifest.icons} />

          {size === 'lg' && <h6 className="ml-3 font-semibold">{app.name}</h6>}
        </div>
      </AppsLink>
    </div>
  )
}
